import React, { useRef, memo, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {getLeafString} from 'effects/midi/tidal/parser.js';
import {expandCycle} from 'effects/midi/tidal/tidal.js';
import Colors from 'components/Colors.js';
const colors = new Colors();


const TidalPart = memo(({effect, cycle, total, parts}) => {
    let ref = useRef(undefined);

    useEffect(() => {
        if (!parts.current[cycle.id]) {
            parts.current[cycle.id] = [];
        }
        parts.current[cycle.id].push(ref);

        return () => {
            if (parts.current[cycle.id]) {
                parts.current[cycle.id] = parts.current[cycle.id].filter(
                    x => x !== ref);
            }
        };
    }, [cycle, parts]);

    let style = {
        width: total + '%'
    };
    let totalLength = 0;

    const getOperand = useCallback((operand) => {
        if (typeof operand === "object") {
            return Math.max(1, Math.floor(effect.var(operand.name)()));
        }
        return Math.floor(operand);
    }, [effect]);

    let className = "tidal-part";
    if (!Array.isArray(cycle)) {
        if (cycle.cycle && Array.isArray(cycle.cycle)) {
            // theres a cycle within it
            for (let part of cycle.cycle) {
                if (part ) {
                    totalLength += (part.operator === "^" || part.operator === "*") ? getOperand(part.operand) : 1;
                }
            }
        } else {
            if (cycle.transpose === null) {
                className += " rest";
            }
            if (cycle.transpose !== null) {
                style.filter = "hue-rotate(" + window.hrotate*cycle.transpose + "deg)";
            }
            //style.backgroundColor = cycle.transpose === null ? undefined :
             //   colors.getColorForHash(getNumberString(getLeafString(cycle)));
        }
    } else {
        for (let part of cycle) {
            if (part) {
                totalLength += (part.operator === "*" || part.operator === "^") ? getOperand(part.operand) : 1;
            }
        }
    }

    return (
        <div
          ref={ref}
          style={style} className={className}>
          {Array.isArray(cycle.cycle || cycle) ?
           (cycle.cycle || cycle)
           .filter(part => part)
           .map((part,i) =>
                (part.operator === "*" || part.operator === "^") ?
                     new Array(getOperand(part.operand)).fill(0).map(
                         (p,j) =>
                             <TidalPart
                               effect={effect}
                               key={i+'-'+j}
                               parts={parts}
                               cycle={part}
                               total={100 / totalLength}
                               />) :
                     <TidalPart
                       parts={parts}
                       effect={effect}
                       key={i}
                       cycle={part} total={100 / totalLength}/>) :
           <span>{getLeafString(cycle, true)}</span>}
        </div>
    );
});

export default TidalPart;
